import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';

@Component({
  selector: 'app-font-selection-menu',
  templateUrl: './font-selection-menu.component.html',
  styleUrls: ['./font-selection-menu.component.scss'],
  standalone: true,
  imports: [ButtonMenuItemComponent, SvgComponent],
})
export class FontSelectionMenuComponent {
  @Input() currentFont: string;
  @Input() defaultFont = 'AkkuratLL';
  @Input() allowFontReset: boolean;
  @Output() onSelected = new EventEmitter();
  @Input() allowRemoveOverrides: boolean;
  @Output() onRemoveOverrides = new EventEmitter();
  fonts = [
    'AkkuratLL',
    'Abril Fatface',
    'Anton',
    'Bodoni Moda',
    'Cormorant',
    'Dancing Script',
    'EB Garamond',
    'Eczar',
    'Inter',
    'Lato',
    'League Spartan',
    'Manjari',
    'Merriweather',
    'MonteCarlo',
    'Montserrat',
    'PT Serif',
    'Parisienne',
    'Philosopher',
    'Playfair Display',
    'Poppins',
    'Prata',
    'Quicksand',
    'Raleway',
    'Roboto',
    'Space Grotesk',
    'Syne',
    'Tenor Sans',
    'Work Sans',
    'Zilla Slab',
  ];

  imageLinks = this.fonts.map(font => {
    // const _font = font === 'Picflow Type' ? 'AkkuratLL' : font;
    return `url("/assets/font-images/${font.toLowerCase()}.png")`;
  });
}
